// @flow
import React from 'react';
import './EmptyListImageComponent.module.scss';

export default class EmptyListImageComponent extends React.PureComponent {
  render() {
    return <div styleName="dd-empty" />;
  }
}
